// Radha — the direct data path.
//
// This is the whole "THB way": the browser talks to Supabase, and Postgres RLS
// is the only thing between a user and the data. No gateway, no bespoke auth, no
// service to deploy. Supabase Auth issues the token; migration 017's policies
// resolve the tenant from it and return only that tenant's rows.
//
// The publishable (anon) key is designed to ship in the browser — it grants
// nothing on its own, because every table is RLS-protected and an anonymous
// caller resolves to no tenant. Real access needs a logged-in session.
import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL as string;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!url || !anonKey) {
  // Fail loudly at boot rather than mysteriously returning no data later.
  throw new Error(
    "VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY must be set (see web/app/.env).",
  );
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // The session lives in this tab's storage; the token carries the identity
    // that RLS reads. Nothing tenant-related is trusted from the client.
    storageKey: "radha.sb.auth",
  },
});
